// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "ServicesSection-module--wrapper--d3ieL";
export var servicesAnnotationWrapper = "ServicesSection-module--servicesAnnotationWrapper--c84PW";
export var servicesAnnotation = "ServicesSection-module--servicesAnnotation--9+ZP7";
export var buttonWrapper = "ServicesSection-module--buttonWrapper--ImbIF";
export var accordionButtonWrapper = "ServicesSection-module--accordionButtonWrapper--SpvCZ";